
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Ertigaonrentinmumbai() {



    const cardData =
    {
        keyword: ' Ertiga on Rent in Mumbai  ',
        heading: 'Deva Cabs: Ertiga on Rent in Mumbai  ',
        headingDescription: 'Deva Cabs provides reliable and budget-friendly Ertiga rentals in Mumbai, perfect for small families, group outings, and city tours. Whether it is a weekend trip, daily commute, or airport transfer, our well-maintained Ertiga offers a smooth and comfortable ride with ample legroom and luggage space. Equipped with air conditioning, push-back seats, and experienced drivers, Deva Cabs ensures your travel is safe, convenient, and enjoyable—at an affordable price.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

   "topPlaces": [
  {
    "title": "Gateway of India",
    "location": "Mumbai, Maharashtra",
    "description": "Located at the waterfront in Colaba, the Gateway of India is Mumbai’s most iconic monument. Built in 1924 to honor the visit of King George V and Queen Mary, this massive basalt arch combines Indo-Saracenic architecture with colonial flair. Overlooking the Arabian Sea and facing the Taj Mahal Palace Hotel, it serves as a central tourist hub, with ferry rides to Elephanta Caves and local photographers capturing the city’s vibrant pulse. The Gateway is not just a historic landmark—it’s a symbol of Mumbai’s pride and resilience."
  },
  {
    "title": "Marine Drive",
    "location": "Mumbai, Maharashtra",
    "description": "Marine Drive is a 3.6-kilometer-long arc-shaped boulevard that stretches from Nariman Point to Girgaon Chowpatty. Also known as the 'Queen’s Necklace' for its glowing curve of street lights at night, it is a beloved seaside promenade for evening walks, breezy bike rides, and romantic sunsets. The backdrop of art deco buildings and the peaceful sound of waves create a rare urban serenity, making Marine Drive a timeless retreat in the heart of Mumbai."
  },
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai Harbour",
    "description": "A UNESCO World Heritage Site, the Elephanta Caves are a complex of ancient Hindu and Buddhist rock-cut temples located on Elephanta Island, about 11 km from Mumbai. These 5th–8th century caves are renowned for their incredible sculptures of Lord Shiva, particularly the 20-foot-high Trimurti—the three-faced form of Shiva representing creation, preservation, and destruction. The island is accessible by ferry from the Gateway of India and offers a tranquil and culturally enriching day trip."
  },
  {
    "title": "Siddhivinayak Temple",
    "location": "Prabhadevi, Mumbai, Maharashtra",
    "description": "The Shree Siddhivinayak Ganapati Mandir is one of Mumbai’s most spiritually significant landmarks, drawing millions of devotees each year. Dedicated to Lord Ganesha, the temple is famous for its beautiful black stone idol with a curved trunk and diamond-studded forehead. Rich in faith, energy, and devotion, the temple also showcases architectural beauty with its carved wooden doors and gold-plated sanctum. Tuesday is considered especially auspicious for darshan, attracting celebrities and commoners alike."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "location": "Mumbai, Maharashtra",
    "description": "A majestic example of Indo-Gothic architecture, Chhatrapati Shivaji Maharaj Terminus is both a UNESCO World Heritage Site and one of India’s busiest railway stations. Designed by British architect F.W. Stevens in 1887, it features elaborate stone carvings, pointed arches, domes, and turrets. The station is a vital part of Mumbai’s daily life while also standing as a living monument to the city’s colonial legacy and artistic grandeur."
  },
  {
    "title": "Juhu Beach",
    "location": "Mumbai, Maharashtra",
    "description": "Juhu Beach is a bustling stretch of sandy coastline in suburban Mumbai, popular for sunsets, local street food, and Bollywood vibes. From joggers and kite-flyers to food stalls selling vada pav, bhel puri, and kulfi, the beach offers a true slice of Mumbai life. Celebrities often frequent nearby luxury homes, and the beach hosts cultural performances and film shoots throughout the year. It's the perfect blend of leisure and local flavor."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Worli, Mumbai, Maharashtra",
    "description": "Built in the 15th century, the Haji Ali Dargah is a white-domed Indo-Islamic shrine located on an islet off the coast of Worli. The dargah houses the tomb of Sufi saint Haji Ali Shah Bukhari and is accessible via a narrow causeway during low tide. The spiritual calm, rhythmic sea waves, and panoramic sea views create a unique experience for visitors of all faiths. It is one of the most peaceful and scenic religious sites in Mumbai."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "Spread across 104 square kilometers, Sanjay Gandhi National Park is Mumbai’s green oasis and a rare natural reserve within a bustling metropolis. The park is home to leopards, deer, monkeys, and countless bird species. A major highlight is the Kanheri Caves—ancient Buddhist cave carvings over 2,000 years old. With toy train rides, cycling trails, nature walks, and boating, the park is a perfect weekend escape for families, nature lovers, and adventure seekers."
  },
  {
    "title": "Chor Bazaar",
    "location": "Bhendi Bazaar, South Mumbai, Maharashtra",
    "description": "One of the oldest and most legendary flea markets in India, Chor Bazaar is a chaotic maze of shops offering antiques, Bollywood posters, vintage cameras, old clocks, and second-hand furniture. Despite the name (meaning 'Thieves Market'), it's a legal and vibrant place known for unexpected treasures and bargaining fun. Whether you're a collector or a curious explorer, this market is a true reflection of Mumbai’s vibrant street economy and layered history."
  },
  {
    "title": "Girgaon Chowpatty",
    "location": "Girgaon, Mumbai, Maharashtra",
    "description": "Girgaon Chowpatty is a central beach located at the northern end of Marine Drive. Known for its lively ambiance, it becomes a focal point during Ganesh Chaturthi for idol immersions. Food stalls offer classic Mumbai street snacks like pani puri, pav bhaji, and kulfi. Families, couples, and students often gather here to watch the sunset, fly kites, or simply relax by the sea. The beach offers both spiritual and recreational charm right in the heart of the city."
  }
],



"services": [
  {
    "name": "Ertiga on Rent in Mumbai",
    "description": "Deva Cabs offers reliable and spacious Ertiga rentals in Mumbai for comfortable group travel. Ideal for city trips, family outings, or business use, our Ertigas are well-maintained, air-conditioned, and chauffeur-driven. Enjoy a smooth ride with affordable rental packages and flexible booking options."
  },
  {
    "name": "Book Ertiga cab Mumbai",
    "description": "Looking to book an Ertiga cab in Mumbai? Deva Cabs makes it simple with quick online booking, instant confirmation, and professional service. Our Ertiga cabs are perfect for airport transfers, local travel, and daily commuting with top-notch comfort and cleanliness."
  },
  {
    "name": "7 seater Ertiga taxi Mumbai",
    "description": "Hire a 7-seater Ertiga taxi in Mumbai with Deva Cabs for comfortable group travel. Whether it’s a short city ride or a long-distance journey, our Ertigas provide ample space, AC, and an economical ride with trusted drivers."
  },
  {
    "name": "Ertiga with driver Mumbai",
    "description": "Get chauffeur-driven Ertiga rentals in Mumbai with Deva Cabs. All our drivers are verified, punctual, and trained to ensure your travel experience is safe and hassle-free. Great for business trips, personal use, and intercity travel."
  },
  {
    "name": "Ertiga for outstation travel Mumbai",
    "description": "Planning an outstation trip from Mumbai? Rent an Ertiga with Deva Cabs for long-distance comfort, reliable performance, and experienced drivers. Our vehicles are ideal for weekend getaways and interstate journeys."
  },
  {
    "name": "Family trip Ertiga rental Mumbai",
    "description": "Make your family trips enjoyable with Ertiga rentals from Deva Cabs. With roomy interiors, AC, and a smooth drive, our 7-seater Ertigas are perfect for group outings and vacations. Book easily with flexible timing and competitive rates."
  },
  {
    "name": "Ertiga airport taxi Mumbai",
    "description": "Book an Ertiga for airport transfers in Mumbai with Deva Cabs. Our drivers ensure timely pickups and drop-offs, and our vehicles offer enough space for luggage and passengers alike. Safe, reliable, and available 24/7."
  },
  {
    "name": "Affordable Ertiga car hire Mumbai",
    "description": "Looking for a budget-friendly 7-seater? Hire an Ertiga in Mumbai at economical rates with Deva Cabs. Clean vehicles, transparent pricing, and courteous drivers make it an excellent value for group travel."
  },
  {
    "name": "Ertiga for corporate use Mumbai",
    "description": "Deva Cabs offers Ertiga rentals tailored for corporate travel in Mumbai. Ideal for staff transport, meetings, and client pickups. Professional drivers and clean, comfortable interiors ensure a seamless business experience."
  },
  {
    "name": "Ertiga for wedding in Mumbai",
    "description": "Book an Ertiga for wedding events in Mumbai with Deva Cabs. Perfect for transporting guests or bridal parties in comfort. Our chauffeurs ensure punctual service and our vehicles are always clean and presentable."
  },
  {
    "name": "Ertiga for local sightseeing Mumbai",
    "description": "Explore Mumbai in comfort with our Ertiga local sightseeing rentals. Great for families or small groups, our vehicles come with AC, a trained driver, and custom tour plans for a memorable city experience."
  },
  {
    "name": "Long distance Ertiga cab Mumbai",
    "description": "Deva Cabs provides Ertiga cabs for long-distance journeys from Mumbai. Travel to Pune, Nashik, Lonavala, or further in comfort. All vehicles are serviced regularly and come with skilled drivers for your peace of mind."
  },
  {
    "name": "AC Ertiga rental Mumbai",
    "description": "Beat the heat with our AC Ertiga rentals in Mumbai. Whether for local, outstation, or business travel, our vehicles offer excellent cooling and comfortable seats to make your journey pleasant and relaxing."
  },
  {
    "name": "Online Ertiga booking Mumbai",
    "description": "Book your Ertiga rental online with Deva Cabs. Our easy-to-use platform gives you instant quotes, confirmed availability, and secure payment options. Perfect for all your travel needs in and around Mumbai."
  },
  {
    "name": "Mumbai to Pune Ertiga taxi",
    "description": "Travel from Mumbai to Pune in a comfortable Ertiga taxi from Deva Cabs. Ideal for small groups or family trips, our service includes AC vehicles, experienced drivers, and affordable one-way or round-trip fares."
  },
  {
    "name": "Ertiga rental for daily commute Mumbai",
    "description": "Need daily commute solutions? Deva Cabs offers flexible Ertiga rentals in Mumbai for office drops, school pickups, and routine travel. Our plans are customizable and affordable, with verified drivers and clean vehicles."
  },
  {
    "name": "Premium Ertiga cab Mumbai",
    "description": "Upgrade your travel experience with our premium Ertiga cab service in Mumbai. Enjoy leather interiors, top-condition vehicles, and skilled chauffeurs for a comfortable and classy ride—perfect for VIP or business travel."
  }
],
"tableData": [
  ["Ertiga on Rent in Mumbai", "-Book Ertiga cab Mumbai"],
  ["7 seater Ertiga taxi Mumbai", "-Ertiga with driver Mumbai"],
  ["Ertiga for outstation travel Mumbai", "-Family trip Ertiga rental Mumbai"],
  ["Ertiga airport taxi Mumbai", "-Affordable Ertiga car hire Mumbai"],
  ["Ertiga for corporate use Mumbai", "-Ertiga for wedding in Mumbai"],
  ["Ertiga for local sightseeing Mumbai", "-Long distance Ertiga cab Mumbai"],
  ["AC Ertiga rental Mumbai", "-Online Ertiga booking Mumbai"],
  ["Mumbai to Pune Ertiga taxi", "-Ertiga rental for daily commute Mumbai"],
  ["Premium Ertiga cab Mumbai", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Spacious and Comfortable for Family and Group Travel",
    "WhyChoosedescription": "Our Ertiga rentals provide ample space and comfort, making them ideal for family outings, small group trips, or city travel around Mumbai. With ergonomic seating and good legroom, every passenger enjoys a relaxed journey."
  },
  {
    "WhyChooseheading": "Suitable for Long-Distance and Outstation Trips",
    "WhyChoosedescription": "The Ertiga is well-suited for long drives with its smooth performance and fuel efficiency. Whether it’s a weekend getaway or an intercity trip, our vehicles ensure a dependable and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Professional and Skilled Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with Mumbai’s traffic and highways, prioritizing your safety, punctuality, and comfort throughout your rental period."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages to Match Your Plans",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans that suit your travel itinerary. Whether for a short city ride or an extended trip, we offer convenient and cost-effective options."
  },
  {
    "WhyChooseheading": "Modern Amenities for a Pleasant Ride",
    "WhyChoosedescription": "Each Ertiga comes equipped with air conditioning, comfortable seating, ample luggage space, and clean interiors, ensuring a comfortable journey for all passengers."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Deva Cabs provides competitive rates with no hidden charges, allowing you to budget your trip with confidence and transparency."
  },
  {
    "WhyChooseheading": "24/7 Availability and Easy Booking",
    "WhyChoosedescription": "Book your Ertiga rental anytime via our website or customer support. Whether it’s a last-minute trip or a planned journey, we offer round-the-clock service for your convenience."
  },
  {
    "WhyChooseheading": "Safe and Well-Maintained Vehicles",
    "WhyChoosedescription": "Safety is our priority. All Ertiga vehicles undergo regular maintenance and safety checks, featuring seat belts and GPS tracking to ensure a secure and comfortable ride."
  }
]









    }










const faqData = [
  {
    question: "Can I rent a Maruti Ertiga in Mumbai with Deva Cabs?",
    answer: "Yes, Deva Cabs offers Maruti Ertiga rentals in Mumbai for city travel, outstation trips, airport transfers, and more."
  },
  {
    question: "What is the seating capacity of the Ertiga?",
    answer: "The Maruti Ertiga typically seats 6 to 7 passengers, making it ideal for small groups, families, or corporate travel."
  },
  {
    question: "Is the Ertiga comfortable for long-distance journeys?",
    answer: "Yes, the Ertiga offers a smooth ride, good mileage, and spacious interiors, making it a great choice for long-distance travel."
  },
  {
    question: "Can I book an Ertiga for outstation travel from Mumbai?",
    answer: "Absolutely. You can hire an Ertiga for outstation destinations such as Lonavala, Shirdi, Pune, Nashik, and more."
  },
  {
    question: "Does the Ertiga rental include a driver?",
    answer: "Yes, all Ertiga rentals from Deva Cabs come with a professional and experienced driver for a hassle-free journey."
  },
  {
    question: "How can I book an Ertiga on rent in Mumbai?",
    answer: "You can book through our website, mobile app, or call our customer service team for easy and quick bookings."
  },
  {
    question: "What are the rental charges for Ertiga in Mumbai?",
    answer: "Rental costs vary based on duration, distance, and travel type. Contact us to get a custom quote for your trip."
  },
  {
    question: "Is the Ertiga suitable for airport transfers?",
    answer: "Yes, the Ertiga is a popular choice for airport transfers due to its comfort, space, and affordability."
  },
  {
    question: "Are there any hidden or additional charges?",
    answer: "No hidden charges. Any extra costs like tolls, parking, or waiting time will be shared upfront during booking."
  },
  {
    question: "Why choose Deva Cabs for Ertiga rental in Mumbai?",
    answer: "Deva Cabs offers well-maintained Ertigas, courteous drivers, affordable rates, and reliable service for a smooth rental experience."
  }
];

const testimonialData = [
  {
    id: 5,
    name: 'Ms. Pooja Sharma',
    role: 'Solo Traveler',
    review: 'I booked an Ertiga from Deva Cabs for a weekend trip to Lonavala. The vehicle was clean and the driver was very cooperative. Great service!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 6,
    name: 'Mr. Kunal Joshi',
    role: 'Corporate Client',
    review: 'Needed a comfortable vehicle for an office group outing and the Ertiga was perfect. Deva Cabs delivered on time and provided excellent support.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga on Rent in Mumbai",
  "image": "https://devacab.com/assets/images/ertiga-on-rent-mumbai.jpg", // Replace with actual image URL
  "description": "Rent 7-seater Ertiga cars in Mumbai with Deva Cabs. Ideal for outstation travel, family trips, airport transfers, corporate use, weddings, and local sightseeing. Affordable, AC, and chauffeur-driven options available.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/ertiga-on-rent-in-mumbai" // Replace with actual page URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Ertiga on Rent in Mumbai | 7 Seater Taxi & Rental | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book 7-seater Ertiga cabs in Mumbai with Deva Cabs. Perfect for outstation trips, family travel, airport transfers, corporate use, weddings, and local sightseeing with affordable, AC, and chauffeur-driven options." 
  />
  <meta 
    name="keywords" 
    content="Ertiga on Rent in Mumbai, Book Ertiga cab Mumbai, 7 seater Ertiga taxi Mumbai, Ertiga with driver Mumbai, Ertiga for outstation travel Mumbai, Family trip Ertiga rental Mumbai, Ertiga airport taxi Mumbai, Affordable Ertiga car hire Mumbai, Ertiga for corporate use Mumbai, Ertiga for wedding in Mumbai, Ertiga for local sightseeing Mumbai, Long distance Ertiga cab Mumbai, AC Ertiga rental Mumbai, Online Ertiga booking Mumbai, Mumbai to Pune Ertiga taxi, Ertiga rental for daily commute Mumbai, Premium Ertiga cab Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/11.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Ertigaonrentinmumbai;